module.exports = __webpack_public_path__ + "img/part4-rIcon2-2.569c72e4.png";